import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('20', '28', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('24', '30', 'NORMAL')};
  }
`;

export const StyledText = styled.div`
  ${pickThemeFontStyles('16', '24', 'NORMAL')};
  color: ${COLORS.DARK_ONYX};
`;

export const StyledWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const StyledButtons = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: space-between;

  button {
    width: 100%;
  }
`;
